// extracted by mini-css-extract-plugin
export default {"switch-tab":"styles_switch-tab__7Ss4S","content__section":"styles_content__section__TeE+w"};